import React from 'react';

/**
 * Component to show a validation error for a form input component.
 *
 * @param error the error message
 * @return the created {@link JSX.Element}.
 * @constructor
 */
export function ValidationErrorMessage({
  error
}: Readonly<{
  error: string;
}>): JSX.Element {
  return (
    <div role="alert" className="error-message">
      {error}
    </div>
  );
}
